export const formatSearchBoxString = (data) => {
  if (!data || typeof data !== "object") return "Invalid Data";

  const {
    type,
    hotel_name,
    address,
    city,
    country,
    hotelid_ppn,
    cityid_ppn,
    state,
    where,
  } = data;

  // Use `where` directly if it's a complete string
  if (where && where.trim().split(",").length >= 2) {
    return where.trim();
  }

  // Fallback values
  const cityName = address?.city_name || city || "Unknown City";
  const stateName = state || "";
  const countryName = country || address?.country_code || "";

  const inferredType = type || (hotelid_ppn ? "hotel" : cityid_ppn ? "city" : null);

  if (inferredType === "hotel") {
    const nameToShow = hotel_name?.trim();
    const parts = [];

    if (nameToShow && nameToShow !== cityName) {
      parts.push(nameToShow);
    }

    parts.push(cityName);

    if (stateName && ![cityName, nameToShow].includes(stateName)) {
      parts.push(stateName);
    }

    if (countryName) {
      parts.push(countryName);
    }

    return parts.join(", ");
  }

  if (inferredType === "city") {
    const parts = [cityName];
    if (stateName && stateName !== cityName) parts.push(stateName);
    if (countryName) parts.push(countryName);
    return parts.join(", ");
  }

  // Final fallback
  return [cityName, stateName, countryName].filter(Boolean).join(", ");
};



export function formatLocationLabel(option, isHotelSearch = false) {
  try {
    const city = option?.city || "";
    const state = option?.state || "";
    const country = option?.country || "";
    const countryCode = option?.country_code || "";
    const hotelName = option?.hotel_name || "";
    const where = option?.where || ""
    let val = "";
    if (hotelName) {
      val = `${hotelName} - ${city}${countryCode ? `, ${countryCode}` : ""}`;
    }

    if (isHotelSearch && !hotelName) {
      val = city;
    }

    if (city && state && country) {
      val = `${city}, ${state}, ${country}`;
    }

    if (city && country) {
      val = `${city}, ${country}`;
    }
    if (city && state && country) {
      val = `${city}, ${state}, ${country}`;
    }

    if (city && state) {
      val = `${city}, ${state}`;
    }

    if (where) {
      val = where
    }



    return val;
  } catch (error) {
    console.error("Error formatting location label:", error);
    return "";
  }
}


export function calculateDateDuration(checkIn, checkOut) {
  const checkInDate = new Date(checkIn);
  const checkOutDate = new Date(checkOut);

  // Calculate difference in milliseconds
  const diffTime = checkOutDate - checkInDate;

  // Convert milliseconds to days
  const durationDays = diffTime / (1000 * 60 * 60 * 24);

  return durationDays;
}

export function filterAirports(list, query) {
  const q = query.toLowerCase().trim();
  const tokens = q.split(/\s+/); // split by spaces

  const matches = list.filter(airport => {
    const city = airport.city?.toLowerCase() || "";
    const airportName = airport.airport?.toLowerCase() || "";
    const iata = airport.iata?.toLowerCase() || "";

    return tokens.every(token =>
      city.includes(token) ||
      airportName.includes(token) ||
      iata.includes(token)
    );
  });

  matches.sort((a, b) => {
    return getAirportMatchScore(a, tokens) - getAirportMatchScore(b, tokens);
  });

  return matches;
}

function getAirportMatchScore(airport, tokens) {
  const fields = [
    airport.city?.toLowerCase() || "",
    airport.airport?.toLowerCase() || "",
    airport.iata?.toLowerCase() || ""
  ];

  let score = 0;
  for (const token of tokens) {
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].startsWith(token)) score += i * 1;
      else if (fields[i].includes(token)) score += i * 10;
      else score += 100;
    }
  }
  return score;
}
